<template>
  <section class="newsletter" aria-labelledby="newsletter-title">
    <h3 id="newsletter-title">Newsletter</h3>
    <p>Occasional updates on our work, projects, and releases.</p>

    <form class="newsletter__form" @submit.prevent="subscribe">
      <label class="newsletter__label" for="newsletter-email">Email address</label>
      <input
        id="newsletter-email"
        v-model.trim="email"
        type="email"
        autocomplete="email"
        placeholder="you@example.com"
        required
        :disabled="submitting"
      />
      <input
        v-model="honeypot"
        class="newsletter__honeypot"
        type="text"
        name="_honey"
        tabindex="-1"
        autocomplete="off"
        aria-hidden="true"
      />
      <button type="submit" :disabled="submitting">
        {{ submitting ? 'Submitting…' : 'Subscribe' }}
      </button>
    </form>
    <p class="newsletter__status" aria-live="polite">{{ status }}</p>
  </section>
</template>

<script>
import { toast } from '@/utilities/toaster';

const SIGNUP_ENDPOINT = 'https://formsubmit.co/ajax/d7a1ab1e3c506057146c9461a0adf40e';

export default {
  name: 'NewsLetters',
  data() {
    return {
      email: '',
      honeypot: '',
      submitting: false,
      status: '',
    };
  },
  methods: {
    async subscribe() {
      if (this.submitting) return;
      this.submitting = true;
      this.status = '';

      try {
        const response = await fetch(SIGNUP_ENDPOINT, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.email,
            _subject: 'New 0xeightnine newsletter signup',
            _honey: this.honeypot,
          }),
        });

        const result = await response.json();
        if (!response.ok || (result.success !== 'true' && result.success !== true)) {
          throw new Error(result.message || `Signup request failed with status ${response.status}`);
        }

        this.status = 'Thanks for subscribing! Your signup has been sent.';
        toast.success(this.status);
        this.email = '';
      } catch (error) {
        this.status = 'We could not submit your signup. Please try again later.';
        toast.error(this.status);
        console.error('Newsletter signup failed.', error);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.newsletter__honeypot {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
}

.newsletter__status {
  min-height: 1.4em;
}

.newsletter__form button:disabled {
  cursor: wait;
  opacity: 0.7;
}
</style>
